import { createTeamUnion } from "@redotech/redo-model/create-team";
import * as z from "zod/v4";

export const createTeam = {
  name: "createTeam" as const,
  input: createTeamUnion,
  output: z.object({
    success: z.boolean(),
    message: z.nullable(z.string()),
    team: z.string().nullable(),
  }),
};
